export var EMessageRequestTypes;

(function (EMessageRequestTypes) {
  EMessageRequestTypes["getSubscription"] = "getSubscription";
})(EMessageRequestTypes || (EMessageRequestTypes = {}));

export var EMessageResponseTypes;

(function (EMessageResponseTypes) {
  EMessageResponseTypes["subscriptionStatus"] = "subscriptionStatus";
  EMessageResponseTypes["workerRegistred"] = "workerRegistred";
})(EMessageResponseTypes || (EMessageResponseTypes = {}));

export var EWindowStaticMethods;

(function (EWindowStaticMethods) {
  EWindowStaticMethods["ready"] = "__push_manager_ready__";
  EWindowStaticMethods["checkSubsciption"] = "__push_manager_check_subscription__";
})(EWindowStaticMethods || (EWindowStaticMethods = {}));